const PRICE_MULTIPLICATOR = 20

function makePrice({ expected, side }) {
  const home = 1 / parseFloat(expected.home)
  const away = 1 / parseFloat(expected.away)
  const draw = 1 / parseFloat(expected.draw)

  const price = ((side === 0 ? home : away) + 0.5 * draw) /
    (home + draw + away) * PRICE_MULTIPLICATOR

  return parseFloat(price.toFixed(2))
}

export default {
  makePrice,
};
